import type { ERedirectURLError } from '@signing-page/api/unversal-link/types/redirect-url-error';
import type { IVerifyLinkResponse } from '@signing-page/api/unversal-link/types/verify-link-response';

export interface IUniversalLinkState {
  loading: boolean;
  loaded: boolean;
  loadingError: boolean;
  verifyLinkResponse: IVerifyLinkResponse;
  loadingRedirectURL: boolean;
  redirectURL: string;
  redirectURLError: ERedirectURLError;
}

export enum EUniversalLinkAction {
  VerifyLink = 'verifyLink',
  VerifyLinkSuccess = 'verifyLinkSuccess',
  VerifyLinkFailed = 'verifyLinkFailed',

  LoadRedirectURL = 'loadRedirectURL',
  LoadRedirectURLSuccess = 'loadRedirectURLSuccess',
  LoadRedirectURLFailed = 'loadRedirectURLFailed',
}

export enum EUniversalLinkMutation {
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetLoadingError = 'setLoadingError',
  SetVerifyLinkResponse = 'setVerifyLinkResponse',
  SetLoadingRedirectURL = 'setLoadingRedirectURL',
  SetRedirectURL = 'setRedirectURL',
  SetRedirectURLError = 'setRedirectURLError',
}
